var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{staticClass:"export-excel",attrs:{"loading":_vm.isFetching},on:{"click":_vm.clickHandler}},[_vm._v("Xuất File Excel")])}
var staticRenderFns = []

export { render, staticRenderFns }